import React from 'react'
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle
} from '@/components/ui/dialog'

export default function SimpleModal ({ contentRef, size, isOpen, onClose, header, body, footer, trigger }) {
  return (
    <>
      {trigger}
      <DialogRoot
        placement='center'
        motionPreset='slide-in-bottom'
        lazyMount
        open={isOpen}
        onOpenChange={(e) => {
          if (typeof onClose !== 'function') return
          if (e?.open === false) onClose()
        }}
        size={size}
        closeOnInteractOutside={false}
      >
        <DialogContent ref={contentRef}>
          <DialogHeader>
            <DialogTitle>{header}</DialogTitle>
            <DialogCloseTrigger />
          </DialogHeader>
          <DialogBody>
            {body}
          </DialogBody>
          {footer && (
            <DialogFooter>
              {footer}
            </DialogFooter>
          )}
        </DialogContent>
      </DialogRoot>
    </>
  )
}
